import MenuIcon from '@mui/icons-material/Menu'
import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import Drawer from '@mui/material/Drawer'
import IconButton from '@mui/material/IconButton'
import Paper from '@mui/material/Paper'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import { ReactNode } from 'react'
import useWindowBody from '../../../hooks/useWindowBody'
import DatePickers from './DatePickers/index'
import IntervalSelect from './IntervalSelect'
import Sidebar from './Sidebar'
import TownSelect from './TownSelect'

type Props = {
  children: ReactNode
  setToggleOpen: (input?: boolean | undefined) => void
  openToggle: boolean
}

const Navbar = ({ children, setToggleOpen, openToggle }: Props) => {
  const body = useWindowBody()

  return (
    <>
      <AppBar position="fixed" sx={{ zIndex: 1200 }}>
        <Toolbar
          sx={{
            justifyContent: 'space-between',
          }}
        >
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={() => setToggleOpen()}
            >
              <MenuIcon />
            </IconButton>
            <Typography variant="h6" noWrap component="div">
              CityOS
            </Typography>
            <Box ml={2} sx={{ display: { xs: 'none', sm: 'block' } }}>
              <Paper elevation={0}>
                <TownSelect />
              </Paper>
            </Box>
          </Toolbar>
          <Toolbar>
            <DatePickers />
            <Box ml={2} sx={{ display: { xs: 'none', sm: 'block' } }}>
              <Paper elevation={0}>
                <IntervalSelect />
              </Paper>
            </Box>
          </Toolbar>
        </Toolbar>
      </AppBar>
      <Drawer
        container={body}
        variant="temporary"
        open={openToggle}
        onClose={() => setToggleOpen()}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
      >
        <Sidebar setToggleOpen={setToggleOpen} />
      </Drawer>
      {children}
    </>
  )
}

export default Navbar
